export enum ImplementationType {
  WEB_REDIRECT = 'WEB_REDIRECT',
  NATIVE_SDK = 'NATIVE_SDK',
}
